import { useTenantSettings } from 'react-common'
import { useTranslation } from 'react-i18next'
import styles from './PrivacyPolicyFooter.module.scss'

export const PrivacyPolicyFooter = () => {
  const { t } = useTranslation()

  const privacyLink = useTenantSettings('platform.branding.privacy_policy_url')

  if (!privacyLink) {
    return null
  }

  return (
    <a className={styles.anchorTag} href={privacyLink} target="_blank" rel="noopener noreferrer">
      {t('userProfile.privacyPolicy')}
    </a>
  )
}
